import { render, staticRenderFns } from "./RuleGroupSidebar.vue?vue&type=template&id=6b7d1dd8&"
import script from "./RuleGroupSidebar.vue?vue&type=script&lang=js&"
export * from "./RuleGroupSidebar.vue?vue&type=script&lang=js&"
import style0 from "./RuleGroupSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports